import React from 'react'
import {Link} from "react-router-dom"

function TagPills({tags,className}) {
    return (
        <React.Fragment>
            <Link to="/" className={`inline-block cursor-pointer no-underline pillsBg mr-2 mb-2 rounded ${className}`}>
                {tags}
            </Link>
        </React.Fragment>
    )
}

export default TagPills
